import React, { useState, useEffect, useCallback } from 'react';
import './GravurfarbenverwaltungComponent.css';
import {
  getGravurfarben,
  createGravurfarbe,
  updateGravurfarbe,
  deleteGravurfarbe
} from '../services/api';

function GravurfarbenverwaltungComponent() {
  const [gravurfarben, setGravurfarben] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editId, setEditId] = useState(null);
  const [formData, setFormData] = useState({
    name: '',
    hexColor: '#000000'
  });

  const loadGravurfarben = useCallback(async () => {
    try {
      const data = await getGravurfarben();
      setGravurfarben(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error('Fehler beim Laden der Gravurfarben:', error);
      setGravurfarben([]);
    }
  }, []);

  useEffect(() => {
    loadGravurfarben();
  }, [loadGravurfarben]);

  const resetForm = () => {
    setFormData({
      name: '',
      hexColor: '#000000'
    });
    setEditId(null);
    setShowForm(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      if (editId) {
        await updateGravurfarbe(editId, formData);
      } else {
        await createGravurfarbe(formData);
      }

      await loadGravurfarben();
      resetForm();
      alert(editId ? 'Gravurfarbe aktualisiert!' : 'Gravurfarbe hinzugefügt!');
    } catch (error) {
      console.error('Fehler beim Speichern:', error);
      const message = error?.response?.data?.error || 'Fehler beim Speichern';
      alert(message);
    }
  };

  const handleEdit = (farbe) => {
    setEditId(farbe.id);
    setFormData({
      name: farbe.name,
      hexColor: farbe.hexColor
    });
    setShowForm(true);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Möchten Sie diese Gravurfarbe wirklich löschen?')) {
      return;
    }

    try {
      await deleteGravurfarbe(id);
      await loadGravurfarben();
      alert('Gravurfarbe gelöscht!');
    } catch (error) {
      console.error('Fehler beim Löschen:', error);
      const serverMessage = error?.response?.data?.error;
      const usedBy = error?.response?.data?.usedBy;
      const message = usedBy && usedBy.length
        ? `${serverMessage} (${usedBy.join(', ')})`
        : serverMessage || 'Fehler beim Löschen';
      alert(message);
    }
  };

  return (
    <div className="gravurfarben-verwaltung">
      <div className="header-actions">
        <h2>Gravurfarben-Verwaltung</h2>
        <button
          className="btn btn-primary"
          onClick={() => setShowForm(!showForm)}
        >
          {showForm ? 'Abbrechen' : 'Neue Gravurfarbe'}
        </button>
      </div>

      {showForm && (
        <div className="card form-card">
          <h3>{editId ? 'Gravurfarbe bearbeiten' : 'Neue Gravurfarbe'}</h3>
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="name">Name *</label>
              <input
                type="text"
                id="name"
                value={formData.name}
                onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                required
                placeholder="z.B. Schwarz, Grau, Rot"
              />
            </div>

            <div className="form-group">
              <label htmlFor="hexColor">Farbe *</label>
              <div className="color-picker-group">
                <input
                  type="color"
                  id="hexColor"
                  value={formData.hexColor}
                  onChange={(e) => setFormData({ ...formData, hexColor: e.target.value })}
                  required
                />
                <input
                  type="text"
                  value={formData.hexColor}
                  onChange={(e) => setFormData({ ...formData, hexColor: e.target.value })}
                  placeholder="#000000"
                  pattern="^#[0-9A-Fa-f]{6}$"
                  title="Hex-Farbcode (z.B. #000000)"
                />
              </div>
            </div>

            <div className="form-actions">
              <button type="submit" className="btn btn-success">
                {editId ? 'Aktualisieren' : 'Hinzufügen'}
              </button>
              <button type="button" className="btn btn-secondary" onClick={resetForm}>
                Abbrechen
              </button>
            </div>
          </form>
        </div>
      )}

      <div className="gravurfarben-list">
        {gravurfarben.length === 0 ? (
          <p>Keine Gravurfarben vorhanden. Fügen Sie eine neue hinzu.</p>
        ) : (
          gravurfarben.map(farbe => (
            <div key={farbe.id} className="gravurfarbe-card">
              <div className="gravurfarbe-preview">
                <div
                  className="color-circle"
                  style={{ backgroundColor: farbe.hexColor }}
                  title={farbe.hexColor}
                />
              </div>
              <div className="gravurfarbe-info">
                <h3>{farbe.name}</h3>
                <p className="color-code">{farbe.hexColor}</p>
              </div>
              <div className="gravurfarbe-actions">
                <button
                  className="btn btn-secondary btn-sm"
                  onClick={() => handleEdit(farbe)}
                >
                  Bearbeiten
                </button>
                <button
                  className="btn btn-danger btn-sm"
                  onClick={() => handleDelete(farbe.id)}
                >
                  Löschen
                </button>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}

export default GravurfarbenverwaltungComponent;
